import { marioConfig } from "../assets/themes/mario";
import { defaultConfig } from "../assets/themes/default-theme";
import { pulpFictionConfig } from "../assets/themes/pulp-fiction";
import { ldcConfig } from "../assets/themes/champions-league";

export const THEMES_TYPE = [
  {
    label: "Ligue des Champions",
    value: "champions-league-theme",
    config: { ...defaultConfig, ...ldcConfig },
  },
  {
    label: "Mario",
    value: "mario-theme",
    config: { ...defaultConfig, ...marioConfig },
  },
  {
    label: "Pulp Fiction",
    value: "pulp-fiction-theme",
    config: { ...defaultConfig, ...pulpFictionConfig },
  },
];
